import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, CreditCard, AlertCircle } from 'lucide-react';

const PaymentRequiredModal = ({ 
  isOpen, 
  onClose, 
  message = 'You need to complete your payment to access this feature.',
  redirectPath = '/settings?tab=billing',
  isFreeTrialMessage = false
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handlePaymentSetup = () => {
    onClose();
    navigate(redirectPath);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <div className="bg-orange-100 p-3 rounded-full mr-4">
              <AlertCircle className="text-orange-600" size={24} />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">
              Upgrade to SignPact Pro
            </h2>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-gray-600 leading-relaxed">
            {message}
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handlePaymentSetup}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-all duration-300 flex items-center justify-center"
          >
            <CreditCard size={18} className="mr-2" />
            {isFreeTrialMessage ? 'Upgrade to SignPact Pro' : 'Get SignPact Pro'}
          </button>
          <button
            onClick={handleClose}
            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-xl font-medium transition-all duration-300"
          >
            Cancel
          </button>
        </div>

        {/* Footer */}
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-500">
            Questions about billing? <a href="mailto:support@signpact.com" className="text-blue-600 hover:text-blue-700">Contact support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentRequiredModal;